import { formatISO } from 'date-fns'
export type Intervals = 'year' | 'month' | 'week' | 'day' | 'hour'

export const createIntervalFromString = (interval: Intervals) => {
  if (interval === 'year') return { from_dt: formatISO(Date.now() - 1000 * 60 * 60 * 24 * 365), to_dt: formatISO(Date.now()) }
  if (interval === 'month') return { from_dt: formatISO(Date.now() - 1000 * 60 * 60 * 24 * 30), to_dt: formatISO(Date.now()) }
  if (interval === 'week') return { from_dt: formatISO(Date.now() - 1000 * 60 * 60 * 24 * 7), to_dt: formatISO(Date.now()) }
  if (interval === 'day') return { from_dt: formatISO(Date.now() - 1000 * 60 * 60 * 24), to_dt: formatISO(Date.now()) }
  if (interval === 'hour') return { from_dt: formatISO(Date.now() - 1000 * 60 * 60), to_dt: formatISO(Date.now()) }
  else return { from_dt: formatISO(Date.now() - 1000 * 60 * 60 * 24 * 365), to_dt: formatISO(Date.now()) }
}
